<script>
  import { Modal } from 'bootstrap';
  import { onMount } from 'svelte';
  export let handleClick = (e) => {};
  let reason = '';
  let addTaskReasonsModal;
  onMount(() => {
    addTaskReasonsModal = new Modal(document.getElementById('taskReasonsModal'), {
      keyboard: false,
    });
  });
  let selectedTypeId;
  export const showModal = (typeId) => {
    selectedTypeId = typeId;
    reason = '';
    addTaskReasonsModal.show();
  };
</script>

<!-- Modal -->
<div
  class="modal fade"
  id="taskReasonsModal"
  tabindex="-1"
  aria-labelledby="taskReasonsModal"
  aria-hidden="true"
>
  <div class="modal-dialog shadow">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title font-size-14"
          id="exampleModalLabel"
        >
          Notes/Reasons (Optional)
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="col-md-12">
          <div class="form-group">
            <label
              for=""
              class="form-label"
            >
              {#if selectedTypeId != undefined && selectedTypeId == 7}
                Review notes by collaborator
              {:else}
                Please tell us why are you making this change
              {/if}
            </label>
            <textarea
              class="form-control"
              bind:value={reason}
              name="example-text-input"
              placeholder="Please tell us why are you making this change"
              rows="6"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
          data-bs-dismiss="modal">Cancel</button
        >
        <button
          type="button"
          class="btn btn-primary m-0 px-4 font-size-12"
          data-bs-dismiss="modal"
          on:click={() => {
            handleClick({ reason });
          }}>Done</button
        >
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .shadow {
    box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.05);
  }
</style>
